"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SideMenuLink = require("./SideMenuLink");
Object.keys(_SideMenuLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SideMenuLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SideMenuLink[key];
    }
  });
});